import { Typography } from '@material-ui/core';
import React from 'react';

const CustomLabel = ({ label = '', localStyles = {} }: { label: string; localStyles?: Object }) => {
  return (
    <Typography variant="subtitle2" style={{ fontWeight: 'bold', ...localStyles }}>
      {label}
    </Typography>
  );
};

export default CustomLabel;
